<template>
  <section>
    <h3 class='mb-3 ml-3'>Latest Activity</h3>
    <v-list v-if='items.length>0' three-line class='pa-0 ma-0 notifications'>
      <template v-for="(item, index) in items" class="notificationWrapper">
      <v-hover v-bind:key="'notification-' + index" class="notificationWrapper" :class="{ isUnread : item.data.read_at == null }">
        <v-list-tile avatar ripple :key="item.id" active-class="" @click="markAsRead(item, index)" slot-scope="{ hover }">
            <v-list-tile-action>
              <v-icon :color="item.color">{{item.data.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <div class="notificationMessage" v-html="item.data.message"></div>
                <div class="timeStampWrapper">
                <small class='timeStamp'>{{ item.created_at | localTime }} ago</small>
              </div>
            </v-list-tile-content>
            <v-icon fab class="clear" :class="{'hover-clear': hover}" @click.prevent="markAsRead(item, index)">clear</v-icon>
        </v-list-tile>
      </v-hover>
        <v-divider v-if="index + 1 < items.length" :key="index" class='thin px-2 mx-2'></v-divider>
      </template>
    </v-list>
    <p class="mx-3" v-else>
      <em>Check here for your latest activity in Groups!  </em>
    </p>
    <div v-if="window < allItems.length" class="ml-3">
      <v-divider class='thin my-2 px-2'></v-divider>
      <div class="loadMore"><span v-on:click="showMore">Load More</span></div>
    </div>
     <v-divider class='thick my-3 mx-2'></v-divider>
     <div class="mx-2 ml-3 announcements">
        <h3 class='mb-3'>Announcements</h3>

        <div class="announcement">
          <div class="timeStampWrapper">
            <small>April 2024</small>
          </div>
          <p><b>We have upgraded Amaze</b><br/>
          We have upgraded Amaze to a new version. If you encounter any errors, please feel free to let us know by emailing
          <a href='mailto: amaze@rti.org'>amaze@rti.org</a> or by <a href="/feedback/create" to="/feedback/create">providing feedback</a>
          </p>
        </div>
        <v-divider class='thin mb-3'></v-divider>
        <div class="announcement">
          <div class="timeStampWrapper">
            <small>June 2023</small>
          </div>
          <p><b>Group activity summary emails and new email settings have arrived.</b><br />
            Group-specific email settings are available in <a href="/profile/edit" to="/profile/edit"
            title="Click here to edit your user profile.">your profile</a> and in the groups you have joined. Now you can choose to receive periodic summary emails about group activity instead of individual notification emails for each new post and you. Additionally, these new settings allow you to control which groups will send you email updates.
          </p>
        </div>
        <v-divider class='thin mb-3'></v-divider>
        <div class="announcement" v-if="this.$auth.check('uber_admin')">
            <div class="timeStampWrapper">
              <small>April 2023</small>
            </div>
            <p><b>Manage Group Membership in Bulk</b><br/>Now there's a quicker and easier way for group administrators to refresh the members of a group! Next time you are making changes to a group's memberships, check out the Bulk Import for Group Members link available in the Manage Members pop-up.
            </p>
        </div>

        <v-divider class='thin mb-3' v-if="this.$auth.check('uber_admin')"></v-divider>
        <div class="announcement">
          <div class="timeStampWrapper">
            <small>September 1, 2022</small>
          </div>
          <p><b>Share your feedback.</b><br/>We’re regularly updating Amaze with new and improved features. Let us know how we can make it work even better for you! <a href="/feedback/create" to="/feedback/create" title="Click here to provide feedback and tell us what you think.">Tell us what you think.</a>
          </p>
        </div>

        <v-divider class='thin mb-2'></v-divider>

        <p>If you encounter any errors, please feel free to let us know by emailing
          <a href='mailto: amaze@rti.org'>amaze@rti.org</a>.
        </p>
     </div>
  </section>
</template>

<style lang="scss" scoped>
  @import "src/styles/variables.scss";

 .v-divider.thick {
        background-color: $amaze-yellow;
  }
  p {
    font-size: 14px;
  }
  .announcements {
    font-size: 14px;
  }
  .notifications {
     hr {
      margin-top: 0px;
      margin-bottom: 0px;
    }
    &.v-list {
      [role="listitem"] {
        .v-list__tile {
          .v-list__tile__action {
            width: 18px;
            max-width: 18px;
            min-width: 18px;
            margin-right: 10px;
            .v-icon {
              font-size: 18px !important;
              color: black;
              align-items: flex-start;
            }
          }
          .v-list__tile__content {
            font-size: 14px;
            font-family: $amaze-text-font-stack;
            color: black;
            .timeStampWrapper {
              font-size: 12px;
              color: $font-color-alt;
            }
          }
        }
      }
    }
    overflow-y: auto;
    a div {
      font-size: 13px;
    }
    strong {
      color: $icon-blue;
    }
    .clear {
      visibility: hidden;
      z-index: 20;
      &.hover-clear {
        visibility: visible;
      }
    }
  }
  .loadMore {
    font-size: 16px;
    font-weight: bold;
    color: $icon-blue;
    font-family: $amaze-header-font-stack;
  }
</style>

<script>
export default {
  data() {
    return {
      window: 6
    };
  },
  computed: {
    allItems() {
      return this.$store.state.notifications;
    },
    items() {
      return this.allItems.filter((item, index) => { return index < this.window - 1; });
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.$store.commit('updateNotifications');
    })
  },
  methods: {
    showMore() {
      this.window += 6;
    },
    markAsRead(item, index) {
      // remove optimistically
      this.$store.state.notifications.splice(index, 1);
      this.$http.post('users/markAsRead', { nid: item.id }).then(
        response => {
          // nothing to do here on success
        },
        response => {
          console.error('[Notification:markAsRead] error occurred attempting to mark notification as read')
        }
      )
    }
  }
};
</script>
